/***
 * Created on 2023/7/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React, {useEffect, useRef, useState} from 'react';
import ModalDialog from "../common/modal_dialog/modalDialog";
import DialogTextInput from "../common/form/dialog_text_input";
import {useOnChange} from "../../hook/form";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiPost, apiPut} from "../../service/api";
import {useTranslation} from "react-i18next";


function AddContactDialog(props) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    const [nicknameStatus, setNicknameStatus] = useState(false);
    const [qidStatus, setQidStatus] = useState(false);
    const QID_PATTERN  = "^([a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,63}|\\d{6,16})$"
    const modalRef = useRef(null);

    const addContactMutation = useMutation({
        mutationFn: (data) => apiPost('/ajax/friend', data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['friend'],
            });
            props.closeModal();
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const {onChange, values, setValues} = useOnChange({
        nickname: '',
        qid: ''
    });

    const onSubmit = async () => {
        await addContactMutation.mutateAsync([values]);
    }

    useEffect(() => {
        if (nicknameStatus && qidStatus) {
            if (values.nickname && values.qid) {
                modalRef.current.disableSubmitButton(false);
            }
        }
        else {
            modalRef.current.disableSubmitButton(true);
        }
    }, [values.nickname, values.qid, qidStatus]);

    return (
        <ModalDialog {...props} submitText={t('@Add@')} submitAction={onSubmit} ref={modalRef}>
            <div className="dialog-content">
                <DialogTextInput label={t("@Nickname@")} name="nickname" value={values.nickname} onChange={onChange} placeholder={t("@Nickname@")} pattern=".{0,40}" setStatus={setNicknameStatus}/>
                <DialogTextInput label={t("@Email or Phone@")} name="qid" value={values.qid} inputMode={"email"} onChange={onChange} required={true} placeholder={t("@Email or Phone@")} pattern={QID_PATTERN} inputType="qid" setStatus={setQidStatus}/>
            </div>
        </ModalDialog>
    );
}

export default AddContactDialog;